var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon icon__radio--unselected--system icon--style--outline icon--size--small",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M8 1.5A6.5 6.5 0 111.5 8 6.5 6.5 0 018 1.5M8 0a8 8 0 108 8 8 8 0 00-8-8z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }